var map = {
	"./captures/1.jpg": 190,
	"./themes/environment/koala.jpg": 191,
	"./themes/environment/quokka.jpg": 192,
	"./themes/message/colourful.jpg": 193,
	"./themes/message/upclose.jpg": 194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;